module.exports = __webpack_public_path__ + "img/icon-1.179bbe41.svg";